export const getBudgetStructureLevel = (path) => path.split('.').length - 1;
